import { useCallback } from 'react';
import { useFreshdeskContextState } from 'store';
import useMessageChannelAdapter from './use-message-channel-adapter';

const resolvePrimaryKeyFromFields = payload => {
  const primaryField = payload?.fields?.find(field => field?.type === 'PRIMARY');

  if (!primaryField) {
    return null;
  }

  return primaryField.name ?? null;
};

const resolveSchemaHostRequestParams = ({ payload, fieldOperation }) => ({
  primaryKey: resolvePrimaryKeyFromFields(payload),
  fieldOperation,
});

const mergeHostDataIntoEntitiesSchemaPayload = (payload, hostData) => {
  const injectedPayload = { ...payload };

  if (hostData.form_options) {
    injectedPayload.form_options = {
      ...injectedPayload.form_options,
      ...hostData.form_options,
    };
  }

  return injectedPayload;
};

const useInjectEntitiesSchemaPayload = () => {
  const { getHostDataForEntitiesSchemaPayload } = useMessageChannelAdapter();
  const { isInteropFlagEnabled } = useFreshdeskContextState();

  return useCallback(
    async (payload, fieldOperation, fieldDetail) => {
      if (!isInteropFlagEnabled('entities')) {
        return payload;
      }

      try {
        const requestParams = resolveSchemaHostRequestParams({ payload, fieldOperation, fieldDetail });
        const hostContext = await getHostDataForEntitiesSchemaPayload(requestParams);

        if (hostContext && typeof hostContext === 'object' && !Array.isArray(hostContext)) {
          return mergeHostDataIntoEntitiesSchemaPayload(payload, hostContext);
        }
      } catch (error) {
        console.error('Failed to inject schema host context into entity payload', error);
      }

      return payload;
    },
    [getHostDataForEntitiesSchemaPayload, isInteropFlagEnabled]
  );
};

export default useInjectEntitiesSchemaPayload;
